import * as api from 'app/resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchSftpAuthenticationTypesDictionaryRequest = () => ({
  type: actionTypes.FETCH_SFTP_AUTHENTICATION_TYPES_DICTIONARY_REQUEST,
});

export const fetchSftpAuthenticationTypesDictionarySuccess = (types) => ({
  type: actionTypes.FETCH_SFTP_AUTHENTICATION_TYPES_DICTIONARY_SUCCESS,
  types,
});

export const fetchSftpAuthenticationTypesDictionaryFailure = () => ({
  type: actionTypes.FETCH_SFTP_AUTHENTICATION_TYPES_DICTIONARY_FAILURE,
});

export const fetchSftpAuthenticationTypesDictionary = () => async (dispatch) => {
  try {
    dispatch(fetchSftpAuthenticationTypesDictionaryRequest());
    const types = await api.fetchSftpAuthenticationTypesDictionary();
    dispatch(fetchSftpAuthenticationTypesDictionarySuccess(types));
  } catch (error) {
    console.error('FETCH_SFTP_AUTHENTICATION_TYPES_DICTIONARY', error);
    dispatch(fetchSftpAuthenticationTypesDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/sftp-authentication-types.actions.js